<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>学生权限管理</h1>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="candidateList"
      :page="currentPage"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      class="elevation-1"
      @update:page="handlePageChange"
      @update:items-per-page="handleItemsPerPageChange"
    >
      <template v-slot:[`item.createdDateTime`]="{ item }">
        {{ formatDateTime(item.createdDateTime) }}
      </template>

      <template v-slot:[`item.phone`]="{ item }">
        {{ item.phone || '-' }}
      </template>

      <template v-slot:[`item.email`]="{ item }">
        {{ item.email || '-' }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small class="mr-2" @click="showEditPermissionDialog(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <edit-permission-dialog ref="editPermissionDialog" />
  </v-container>
</template>

<script>
import { userApi } from '@/api/user'
import EditPermissionDialog from '@/components/EditPermissionDialog.vue'
import dayjs from 'dayjs'

export default {
  components: {
    EditPermissionDialog
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "账号", value: "account" },
        { text: "姓名", value: "name" },
        { text: "电话", value: "phone" },
        { text: "邮箱", value: "email" },
        { text: "创建时间", value: "createdDateTime" },
        { text: "操作", value: "actions", sortable: false }
      ],
      candidateList: [],
      selectedMemberCoursePermission: {},
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [10,30,50,100],
      totalItems: 10,
    };
  },

  async created() {
    await this.fetchCandidateList();
  },

  methods: {
    async fetchCandidateList() {
      this.loading = true;
      try {
        const response = await userApi.getCandidateList(this.currentPage, this.itemsPerPage);
        this.candidateList = response.data.candidateBasicInfos;
        this.totalItems = response.data.totalItems;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取列表失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(newPage) {
      this.currentPage = newPage
      this.fetchCandidateList()
    },

    handleItemsPerPageChange(newSize) {
      this.itemsPerPage = newSize
      this.currentPage = 1
      this.fetchCandidateList()
    },


    formatDateTime(datetime) {
      return datetime ? dayjs(datetime).format('YYYY-MM-DD HH:mm:ss') : '';
    },

    showEditPermissionDialog(item) {
      this.$refs.editPermissionDialog.open(item);
    }
  },
};
</script>
